import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import cmsHomepageSectionCommunityFavoriteTableColumns from '../../molecules/table-column/cms-homepage-section-community-favorite-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.func,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns       : PropTypes.arrayOf(PropTypes.string),
  isLoading           : PropTypes.bool,
  onActionButtonClick : PropTypes.func
}

const defaultProps = {
  rowButtonProps: {
    buttonText       : '',
    buttonColour     : '',
    isButtonDisabled : () => {},
    onButtonClick    : () => {}
  },
  isLoading           : false,
  onActionButtonClick : () => {}
}

/**
 * Table to display List of CMS Homepage Section for Community Favorite
 * @param {Array<Object>} data - array of community_favorites objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 * @param {boolean} isLoading - whether the table is currently loading data from the backend
 * @param {Function} onActionButtonClick - function that will handle pop up edit modal
 */

const CmsHomepageSectionCommunityFavoriteTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  onActionButtonClick
}) => {

  const columns = useMemo(() => cmsHomepageSectionCommunityFavoriteTableColumns({ onActionButtonClick }),[ onActionButtonClick ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

CmsHomepageSectionCommunityFavoriteTable.propTypes    = propTypes
CmsHomepageSectionCommunityFavoriteTable.defaultProps = defaultProps

export default CmsHomepageSectionCommunityFavoriteTable
